import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/Components/Assistant/AssistantButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CourseDetailView"] */ "/vercel/path0/app/courses/[courseId]/CourseDetailView.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
